import { deserialize, deserializeAs } from "cerialize";
import { Document } from "./document";
import { Breadcrumb } from "../breadcrumb";

export enum NodeType {
  FILE = 'FILE',
  FOLDER = 'FOLDER',
}

export class Node {

  @deserialize
  id: number;

  @deserialize
  name: string;

  @deserialize
  slug: string;

  @deserialize
  path: string;

  @deserializeAs(Node)
  children: Node[];

  @deserializeAs(Document)
  document: Document;

  @deserialize
  root: boolean;

  @deserialize
  writable: boolean;

  @deserialize
  editable: boolean;

  @deserialize
  deletable: boolean;

  @deserializeAs('is_document_carnet')
  isDocumentCarnet: boolean;

  @deserializeAs('is_document_residence')
  isDocumentResidence: boolean;

  @deserializeAs('is_document_logement')
  isDocumentLogement: boolean;

  @deserializeAs('can_share')
  canShare: boolean;

  @deserializeAs('add_folders')
  addFolders: boolean;

  @deserializeAs('document_obligatoire_folder')
  documentObligatoireFolder: boolean;

  get type() {
    return this.document ? NodeType.FILE : NodeType.FOLDER;
  }

  private readonly PATH_SEPARATOR = '/';

  getNode(path: string): Node {
    const chunks = path.split(this.PATH_SEPARATOR);
    const slug = chunks.shift();
    const node = this.findChildBySlug(slug);

    if (node && chunks.length > 0) {
      return node.getNode(chunks.join(this.PATH_SEPARATOR));
    } else {
      return node;
    }

  }

  getBreadcrumbs(path: string, root?: Breadcrumb): Breadcrumb[] {
    const chunks = path.split(this.PATH_SEPARATOR);

    const breadcrumbs: Breadcrumb[] = [];
    if (root) {
      breadcrumbs.push(root);
    }
    const currentTree = [];

    chunks.forEach(chunk => {
      currentTree.push(chunk);
      const currentPath = currentTree.join(this.PATH_SEPARATOR);
      const node = this.getNode(currentPath);
      if (node) {
        breadcrumbs.push(new Breadcrumb(node.name, (root ? root.path + this.PATH_SEPARATOR : '') + currentPath));
      }
    });

    return breadcrumbs;
  }

  findChildBySlug(slug: string): Node {
    return this.children.find(node => {
      return node.slug == slug
    }) || null;
  }

  get deep(): number {
    return this.path.split(this.PATH_SEPARATOR).length
  }

}
